import { useEffect } from "react";
import { BigLogo } from "../../assets/icons";
import LayoutWrapper from "../../layouts/landing-page-layout-wrapper/layoutWrapper";
import styles from "./terms.module.scss";

// import img from 
const DeleteInstructionPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <BigLogo height={300} className={styles.image} />
                <LayoutWrapper>
                    <div className={styles.headerTextWrapper}>
                        <h2 className={styles.headerText}>How to Delete your Account on Xepp</h2>
                        <p className={styles.subHeader}>LAST UPDATED 28TH, APRIL, 2025</p>
                    </div>
                </LayoutWrapper>
            </div>
            <LayoutWrapper>
                <div className={`${styles.termsBody} ${styles.privacyWrapper}`}>
                   <div>
                    <div style={{ marginBottom: 10}}>
                     <p className={styles.hUnderline}>Step 1:</p>
                     <p className={styles.instructionText}>Access your mobile app and log in using your registered credentials.</p>
                    </div>
                    <div>
                    <p className={styles.hUnderline}>Step 2:</p>
                    <p className={styles.instructionText}>Once logged in, proceed to the <strong>ACCOUNT</strong> section. You can easily locate this at the menu listed below.</p>
                    </div>
                   </div>
                    <div className={styles.instructionImageBox}>
                      <img className={styles.responsiveImage} src={"../../../images/delete-ins-1.png"} alt="Delete Instruction" />
                    </div>
                    <p className={styles.hUnderline} style={{ marginTop: 5, marginBottom: 10}}>Step 3:</p>
                    <div className={styles.instructionImageBox}>
                      <img className={styles.responsiveImage} src={"../../../images/delete-ins-2.png"} alt="Delete Instruction" />
                    </div>
                    <p className={styles.finalIns}>Choose <strong>"YES"</strong> to confirm the deletion. Upon selection, your account deletion process will initiate and upon successful completion, you'll receive confirmation of the deletion.
                    For more enquires and assistance, kindly reach out to us on <span>support@bpsafrica.com</span></p>
                </div>
            </LayoutWrapper>
        </div>
    );
};
export default DeleteInstructionPage;
